import { call, put } from 'redux-saga/effects';
import { SignalingSocket } from 'services/signaling';
import { Action } from '@reduxjs/toolkit';
import { displaySimpleNotification } from 'features/notifications/simple-notifications/displaySimpleNotification';
import i18n from 'i18n';

export function* requestBreakoutAssistanceSaga() {
  yield call(SignalingSocket.send, { event: 'requestBreakoutModerator' });

  const notificationThunk: Action = yield call(displaySimpleNotification, {
    content: i18n.t('notifications:breakout_rooms.assistance_requested'),
  });
  yield put(notificationThunk);
}
